// Reine Helfer für die Gewichtsstatistik.

export const formatDate = (dateString) =>
    new Date(dateString).toLocaleDateString('de-DE', {
        day: '2-digit',
        month: 'short',
    });

// Nivo erwartet das Format: [{ id, data: [{ x, y }] }]
export const buildNivoData = (verlauf, startGewicht, startDatum) => {
    const raw = Array.isArray(verlauf) ? [...verlauf] : [];

    // Startpunkt ggf. voranstellen
    if (startGewicht != null && startGewicht !== '') {
        const sw = Number(startGewicht);
        const alreadyIn = raw.some((d) => Number(d.gewicht) === sw);
        if (!alreadyIn) {
            const datum =
                startDatum || (raw.length ? raw[0].datum : new Date().toISOString());
            raw.unshift({ datum, gewicht: sw });
        }
    }

    return [
        {
            id: 'gewicht',
            color: '#3b82f6',
            data: raw.map((d) => ({
                x: d.datum,
                y: Number(d.gewicht),
            })),
        },
    ];
};

// Kalorienbedarf (Erhaltung/Ziel) aus Statistik-Daten berechnen.
export const berechneKalorien = (statistik) => {
    if (!statistik) return null;

    const { nutzer, kalorienBedarf } = statistik;
    const currentWeight = Number(statistik.aktuelles_gewicht ?? statistik.start_gewicht ?? 0);
    const height = Number(nutzer?.groesse ?? 0);

    let alter = 0;
    try {
        if (nutzer?.geb_datum) {
            const bd = new Date(nutzer.geb_datum);
            const today = new Date();
            alter = today.getFullYear() - bd.getFullYear();
            const m = today.getMonth() - bd.getMonth();
            if (m < 0 || (m === 0 && today.getDate() < bd.getDate())) alter--;
        }
    } catch (e) {
        alter = 0;
    }

    let bmr = 0;
    if (nutzer?.geschlecht === 'm') {
        bmr = 10 * currentWeight + 6.25 * height - 5 * alter + 5;
    } else if (nutzer?.geschlecht === 'w') {
        bmr = 10 * currentWeight + 6.25 * height - 5 * alter - 161;
    } else {
        bmr = 10 * currentWeight + 6.25 * height - 5 * alter - 78;
    }

    const aktivitaetsMultiplikator = {
        sedentary: 1.2,
        light: 1.375,
        moderate: 1.55,
        active: 1.725,
        very_active: 1.9,
    };

    const activityKey = nutzer?.aktivitaetslevel || 'moderate';
    const multiplier = aktivitaetsMultiplikator[activityKey] ?? aktivitaetsMultiplikator['moderate'];
    const erhaltungskalorien = Math.round(bmr * multiplier);

    const apiDefizit = Number(kalorienBedarf?.defizit ?? NaN);
    const emp = kalorienBedarf?.empfehlung || 'moderate';
    const defaultDefizitByEmp = { aggressive: 800, moderate: 500, slow: 250 };
    const defaultDefizit = defaultDefizitByEmp[emp] ?? 500;
    const defizit = Number.isFinite(apiDefizit) ? Math.abs(apiDefizit) : defaultDefizit;

    const ziel = Number(statistik.ziel_gewicht ?? NaN);
    const weightDiff =
        Number.isFinite(ziel) && Number.isFinite(currentWeight) ? ziel - currentWeight : 0;

    let zielKalorien = erhaltungskalorien;
    let mode = 'maintain';
    if (Number.isFinite(weightDiff) && weightDiff < 0) {
        zielKalorien = Math.round(erhaltungskalorien - Math.abs(defizit));
        mode = 'deficit';
    } else if (Number.isFinite(weightDiff) && weightDiff > 0) {
        zielKalorien = Math.round(erhaltungskalorien + Math.abs(defizit));
        mode = 'surplus';
    }

    return { erhaltung: erhaltungskalorien, zielKalorien, defizit, empfehlung: emp, mode };
};
